/**
 * Catégories du blog + helpers de formatage.
 * Module volontairement léger : il peut être importé par les pages sans
 * embarquer le corpus complet des articles (`blog.ts` / `blog-longform.ts`).
 */

export type BlogCategory = {
  slug: string;
  name: string;
  title: string;
  description: string;
  intro: string;
};

export const blogCategories: BlogCategory[] = [
  {
    slug: "histoire",
    name: "Histoire",
    title: "Histoire de la Corse : articles, repères et archives",
    description:
      "Articles d'histoire corse : chronologie, grandes dates, personnages et archives filmées ou écrites, expliqués simplement.",
    intro:
      "Des repères clairs sur l'histoire de l'île, adossés aux reportages du catalogue et aux archives de presse.",
  },
  {
    slug: "banditisme",
    name: "Banditisme",
    title: "Banditisme corse : dossiers, procès et reportages",
    description:
      "Le grand banditisme corse expliqué : Brise de mer, règlements de comptes, procès et enquêtes télévisées à revoir.",
    intro:
      "Les grands dossiers du banditisme insulaire, remis en contexte et reliés aux documentaires disponibles.",
  },
  {
    slug: "nationalisme",
    name: "Nationalisme & FLNC",
    title: "Nationalisme corse et FLNC : analyses et documentaires",
    description:
      "Nationalisme corse, FLNC, autonomie : articles de fond et sélection de reportages pour comprendre cinquante ans de luttes.",
    intro:
      "Comprendre le mouvement national corse, de 1975 à aujourd'hui, à travers les archives audiovisuelles.",
  },
  {
    slug: "politique",
    name: "Politique corse",
    title: "Politique corse : institutions, élus et débats",
    description:
      "Politique corse : collectivité unique, autonomie, élus et campagnes, décryptés et illustrés par les reportages du catalogue.",
    intro:
      "Institutions, élections et débats insulaires, avec les documentaires et articles de presse associés.",
  },
  {
    slug: "culture",
    name: "Culture & patrimoine",
    title: "Culture corse : chant, langue, villages et patrimoine",
    description:
      "Culture corse : polyphonies, langue, confréries, villages et traditions, avec les meilleurs reportages à revoir.",
    intro:
      "Le patrimoine vivant de l'île : chant, langue, fêtes et savoir-faire, en articles et en vidéos.",
  },
  {
    slug: "societe",
    name: "Société & économie",
    title: "Société et économie en Corse : actus et décryptages",
    description:
      "Économie corse, immobilier, entreprises et vie locale : les sujets de société de l'île, décryptés et illustrés par les reportages.",
    intro:
      "L'actualité économique et sociale de la Corse, mise en perspective avec les reportages et archives du catalogue.",
  },
];

export function blogCategory(slug: string) {
  return blogCategories.find((c) => c.slug === slug);
}

export function formatBlogDate(iso: string) {
  const [y, m, d] = iso.split("-");
  const months = [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
  ];
  return `${Number(d)} ${months[Number(m) - 1]} ${y}`;
}
